<template>
  <div class="loading-spinner-wrapper" :class="{ 'full-page': fullPage }">
    <div 
      class="loading-spinner" 
      :class="size"
      :aria-label="ariaLabel"
      role="status"
    ></div>
    <p v-if="message" class="loading-message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].includes(value)
    },
    message: {
      type: String,
      default: ''
    },
    fullPage: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: 'Loading'
    }
  }
}
</script>

<style scoped>
.loading-spinner-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.loading-spinner-wrapper.full-page {
  padding: 48px 24px;
}

.loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-left-color: #4ecdc4;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

.loading-spinner.small {
  width: 20px;
  height: 20px;
  border-width: 3px;
  margin-bottom: 8px;
}

.loading-spinner.medium {
  width: 32px;
  height: 32px;
  border-width: 4px;
  margin-bottom: 12px;
}

.loading-spinner.large {
  width: 48px;
  height: 48px;
  border-width: 5px;
  margin-bottom: 16px;
}

.loading-message {
  font-size: 14px;
  color: #bbb;
  margin: 0;
  font-weight: 400;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .loading-spinner {
    animation: none;
    border-left-color: rgba(255, 255, 255, 0.3);
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .loading-spinner {
    border-color: #ffffff;
    border-left-color: #4ecdc4;
  }
}
</style>